import { ArrowDown2, DiscountShape } from 'iconsax-react';
import { Banknote, CalendarCheck2, CalendarDays, Clock, LandPlot, MapPin, MinusCircle, Phone, PlusCircle, ShoppingCart, Timer, Trash2 } from 'lucide-react';
import moment from 'moment';
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from 'react-hook-form'; // Use useForm hook
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AppLinkIconSet from '../Components/AppLinkIconSet.jsx';
import { bookCourt, courtVenueSportFilter, getAddonsFromSport, getCalculatedSlotPrice, getSlots, normalCourtPayment, partialBookingCourtPayment, paymentOrderId, splitPaymentCourtPayment } from '../Utils/API.jsx';
import { formBtn1, inputClass } from '../Utils/CustomClasses.jsx';
import usePaymentValidation from '../Utils/hooks/usePaymentValidation.js';

const initialNormalBookingState = {
    gstPercentage: 0,
    platformCharges: 0,
    slotPrice: 0.0,
    addonPrice: 0.0,
    discountedPrice: 0.0,
    gstPrice: 0.0,
    platformFeePrice: 0.0,
    totalAmount: 0.0
}

const initialPartialBookingState = {
    slotPrice: 0.0,
    addonPrice: 0.0,
    discountedPrice: 0.0,
    gstPrice: 0.0,
    platformFeePrice: 0.0,
    totalAmount: 0.0,
}

function SlotBooking() {
    // Initialize useForm
    // console.log('route====================', route)
    const navigation = useNavigate();
    const venueDetails = useSelector(state => state?.sport?.bookingCourt);
    // console.log('venueDetails', venueDetails)
    const Userdetails = useSelector(state => state.user?.userDetails)
    const { register, handleSubmit, setValue, watch, reset, } = useForm();
    // const { bookingDetails: bookingData } = route.params
    // const [bookingDetails, setBookingDetails] = useState(bookingData)
    const [timeOpen, setTimeOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [duration, setDuration] = useState(1);
    const [selectedSlot, setSelectedSlot] = useState([]);
    const [Addons, setAddOns] = useState([])
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableSlots, setAvailableSlots] = useState([]);
    const [bookingRegistered, setBookingRegistered] = useState(null);
    const [selectedCourtState, setSelectedCourtState] = useState(null);
    const [courtList, setCourtList] = useState([]);
    const [slotData, setSlotData] = useState(null);
    const [selectedAddons, setSelectedAddons] = useState([]);
    const [splitAmountData, setSplitAmountData] = useState({
        slotPrice: 0.0,
        addonPrice: 0.0,
        taxPrice: 0.0,
        totalAmount: 0.0
    });
    const [couponObjectData, setCouponObjectData] = useState({name: "", obj: null, errorMessage: ""})
    const [partialPayment, setPartialPayment] = useState(false)
    const [partialPaymentDetails, setPartialPaymentDetails] = useState({
        slotAmount: 0,
        addonAmount: 0,
        taxAmount: 0,
        totalAmount: 0
    });

    const [toggleDropDown, setToggleDropDown] = useState({
        normalPriceBreakup: true
    })

    // State Variable that holds details regarding the normal booking
    const [normalBookingFields, setNormalBookingFields] = React.useState(initialNormalBookingState);

    // State Variable that holds details regarding the partial booking
    const [partialBookingFields, setPartialBookingFields] = React.useState(initialPartialBookingState);

    const [calculatedResponse, setCalculatedResponse] = React.useState(null);

    const {isPaymentAllowed, warnUserBeforeBooking, navigateToEditProfile} = usePaymentValidation();

    // Calculate slot end time with venue closing time constraint (matching mobile app logic)
    const slotEndTime = useMemo(() => {
        if (!selectedSlot || selectedSlot.length === 0 || !venueDetails?.booking_closing_time || !selectedCourtState?.slot_duration) {
            return '--';
        }

        const calculatedSlotEndTime = moment(selectedSlot[selectedSlot.length - 1], 'HH:mm').add(selectedCourtState?.slot_duration, 'minutes');
        const closingTime = moment(venueDetails?.booking_closing_time, 'HH:mm:ss');

        // Use the minimum of the calculated end time and the closing time
        const finalSlotEndTime = calculatedSlotEndTime.isAfter(closingTime) ? closingTime : calculatedSlotEndTime;

        return finalSlotEndTime.format('HH:mm:ss');
    }, [selectedSlot, selectedCourtState?.slot_duration, venueDetails?.booking_closing_time]);

    const selectedSport = watch('sport')
    const selectedCourt = watch('court')
    const dropdownRef = useRef(null);
    const unitSlotPriceObject = venueDetails?.sports_price?.find(sportPriceData => sportPriceData?.sport == selectedSport?.value && sportPriceData?.court == selectedCourt)

    const sportsOptions = venueDetails?.sports?.map((sport) => ({
        value: sport.sport.id,
        label: sport.sport.sport_name,
        image: sport.sport.sport_image,
    }));

    const generateSlots = (startTime, endTime, bookedSlots, blockedSlots, slotDuration = 60) => {
        const slots = [];
        const start = moment(startTime, 'HH:mm');
        const end = moment(endTime, 'HH:mm');

        while (start.isBefore(end)) {
            const slot = start.format('HH:mm');
            slots.push(slot);
            start.add(slotDuration, 'minutes');
        }

        // console.log("Generated Slots:", slots); // Log generated slots
        // const allSlots = slots.filter(slot => !bookedSlots.includes(slot) && !blockedSlots.includes(slot));
        // console.log("Filtered Slots:", allSlots); // Log available slots after filtering

        return slots;
    };


    const getAllSlots = () => {
        // Don't make API call if court is not selected
        if (!selectedCourt) {
            setAvailableSlots([]);
            setSlotData({});
            return;
        }

        const payload = {
            venue_id: venueDetails?.id,
            date: moment(selectedDate).format('YYYY-MM-DD'),
            court_id: selectedCourt
        };

        setAvailableSlots([]); // Reset available slots
        setSlotData({}); // Reset slot data

        getSlots(payload).then(res => {
            if (res?.data) {
                const slotData = res?.data?.data || {};
                const { start_time, end_time, booked_slots, blocked_slots } = slotData;
                setSlotData(slotData)
                if (start_time && end_time && selectedCourtState?.slot_duration) {
                    const availableSlots = generateSlots(start_time, end_time, booked_slots, blocked_slots, selectedCourtState?.slot_duration);
                    setAvailableSlots(availableSlots);
                } else {
                    console.log("Invalid start or end time");
                }
            }
        });
    };    

    const fetchAddonApi = (venueId, sportId) => {
        getAddonsFromSport(venueId, sportId).then((res) => {
            if (res?.data?.length > 0) {
                const formattedAddonData = res?.data?.map((item) => {
                    return { ...item, quantity: 0 }
                })
                setSelectedAddons(formattedAddonData);
            } else {
                setSelectedAddons([]);
            }
        })
    }

    const onIncrement = (addonId) => {
        let newData = []
        setSelectedAddons(prevAddonList => {
            newData = prevAddonList.map(addon => {
                if (addon.id == addonId) {
                    return { ...addon, quantity: addon.quantity + 1 }
                } else {
                    return addon
                }
            })
            return newData
        })
    };

    const onDecrement = (addonId) => {
        let newData = []
        setSelectedAddons(prevAddonList => {
            newData = prevAddonList.map(addon => {
                if (addon.id == addonId) {
                    return { ...addon, quantity: addon.quantity - 1 < 0 ? 0 : addon.quantity - 1 }
                } else {
                    return addon
                }
            })
            return newData
        })
    };

    const getSlotPrice = async (startTime, endTime, venueId, courtId, sportId, specificDate, addonList, couponId, partialPayment) => {
        // console.log(startTime, endTime, venueId, courtId, sportId, specificDate, addonList, couponId, partialPayment);
        try {
            const res = await getCalculatedSlotPrice({
                start_time: startTime,
                end_time: endTime,
                venue: venueId,
                court: courtId,
                sport: sportId,
                specific_date: specificDate,
                weekday: moment(specificDate).format("dddd"),
                addons_list: addonList,
                coupon_id: couponId,
                partial_payment: partialPayment
            });
            return res?.data
        } catch (err) {
            console.log(err);
            return 0; // Return 0 if there is an error
        }
    };
    
    const calculate = async () => {
        const formattedSelectedAddons = selectedAddons?.map(item => {
            return {
                id: item?.id,
                quantity: item?.quantity
            }
        })

        const requestedSlotData = {
            venue: venueDetails?.id,
            court: selectedCourt,
            sport: selectedSport?.value,
            date: moment(selectedDate).format('YYYY-MM-DD'),
            start_time: moment(selectedSlot[0], 'HH:mm').format('HH:mm:ss'),
            end_time: slotEndTime,
            weekday: moment(selectedDate).format("dddd"),
            addons: formattedSelectedAddons,
            couponId: couponObjectData?.obj?.id || null,
            partialPayment: partialPayment
        }

        const normalCalculatedPrices = await getSlotPrice(
          requestedSlotData?.start_time,
          requestedSlotData?.end_time,
          requestedSlotData?.venue,
          requestedSlotData?.court,
          requestedSlotData?.sport,
          requestedSlotData?.date,
          requestedSlotData?.addons,
          requestedSlotData?.couponId,
          requestedSlotData?.partialPayment
        );
        setCalculatedResponse(normalCalculatedPrices)

        const normalBookingResponse = {
            gstPercentage: normalCalculatedPrices?.gst_percentage,
            platformCharges: normalCalculatedPrices?.platform_fee_percentage,
            slotPrice: normalCalculatedPrices?.total_slot_price,
            addonPrice: normalCalculatedPrices?.addon_price,
            discountedPrice: normalCalculatedPrices?.discount_price,
            gstPrice: normalCalculatedPrices?.gst_amount,
            platformFeePrice: normalCalculatedPrices?.platform_fee,
            totalAmount: normalCalculatedPrices?.total_price,
        }
        setNormalBookingFields(normalBookingResponse)

        const partialBookingResponse = {
            slotPrice: normalCalculatedPrices?.partial_total_slot_price,
            addonPrice: normalCalculatedPrices?.partial_addon_price,
            discountedPrice: normalCalculatedPrices?.partial_discount_price,
            gstPrice: normalCalculatedPrices?.partial_gst_amount,
            platformFeePrice: normalCalculatedPrices?.partial_platform_fee,
            totalAmount: normalCalculatedPrices?.partial_total_price,
        }
        setPartialBookingFields(partialBookingResponse)
    }

    const handleSlotClick = useCallback((slotStartTime) => {
        let newData = [];
        const timeRange = `${slotStartTime} - ${moment(slotStartTime,'HH:mm').add(selectedCourtState.slot_duration, 'minutes').format('HH:mm')}`;

        setSelectedSlot((prevState) => {
            const isPresent = prevState?.includes(slotStartTime);
            if (!isPresent) {
                if (prevState?.length > 0) {
                    const prevSelected = prevState.map((prevSelectedSlotStartTime) => {
                        return `${prevSelectedSlotStartTime} - ${moment(prevSelectedSlotStartTime,'HH:mm').add(selectedCourtState.slot_duration, 'minutes').format('HH:mm')}`;
                    })

                    // Extract all previously selected start & end times
                    const allTimes = [...prevSelected, timeRange].map(slot => {
                        const [start, end] = slot.split(' - ').map(t => moment(t, 'HH:mm'));
                        return { start, end, raw: slot };
                    });
    
                    // Sort by start time
                    const sortedTimes = allTimes.sort((a, b) => a.start.diff(b.start));
                    const minStart = sortedTimes[0].start;
                    const maxEnd = sortedTimes[sortedTimes.length - 1].end;
    
                    const slots = [];
                    let currentSlot = moment(minStart);
                    let conflictFound = false;
    
                    while (currentSlot.isBefore(maxEnd) && !conflictFound) {
                        const nextSlot = moment(currentSlot).add(selectedCourtState.slot_duration, 'minutes');
                        const formattedSlot = `${currentSlot.format('HH:mm')}`;
    
                        // Check if the current slot is booked or blocked
                        if (slotData.booked_slots.includes(currentSlot.format('HH:mm')) || slotData.blocked_slots.includes(currentSlot.format('HH:mm'))) {
                            conflictFound = true;
                        } else {
                            slots.push(formattedSlot);
                            currentSlot = nextSlot;
                        }
                    }
                    newData = slots;
                } else {
                    newData = [slotStartTime];
                }
            } else {                
                if (prevState?.length > 0) {
                    const isTerminalValue = prevState[prevState.length - 1] === slotStartTime || prevState[0] === slotStartTime;                    
                    if (isTerminalValue) {
                        newData = prevState.filter((item) => item !== slotStartTime);
                    } else {
                        const matchedIndex = prevState.findIndex((item) => item === slotStartTime);
                        newData = [...prevState.slice(0, matchedIndex + 1)];
                    }
                }
            }
            return newData;
        });
    }, [slotData]);
    

    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div
            onClick={onClick}
            ref={ref}
            className="flex items-center border border-gray-300 rounded-md px-3 py-2 cursor-pointer w-full bg-white"
        >
            <input
                value={value}
                readOnly
                placeholder="Pick a date"
                className="flex-1 w-[10%] bg-transparent focus:outline-none text-gray-700"
            />
            <CalendarDays className="text-gray-500 ml-2" />
        </div>
    ));

    const discardFunc = () => {
        reset(); // Reset form state
        setValue('sport', undefined)
        setSelectedSlot(null);
        setDuration(1);
        setCouponObjectData({name: '', obj: null, errorMessage: ""})
        setSelectedAddons([]);
    }

    const handelCoupon = () => {
        if (couponObjectData?.name) {
            let foundMatchingCoupon = null
            venueDetails?.coupons?.filter((item) => {
                if (item?.name == couponObjectData?.name) {
                    foundMatchingCoupon = item
                }
            })
            if (foundMatchingCoupon) {
                setCouponObjectData(prevState => {return {...prevState, obj:foundMatchingCoupon, errorMessage: "" }})    
            } else {
                setCouponObjectData(prevState => {return {...prevState, obj:null, errorMessage: "Invalid Coupon" }})
            }
        } else {
            setCouponObjectData(prevState => {return {...prevState,obj: null, errorMessage: "Please fill the coupon field first" }})
        }
    }

    const generateOrderId = async (amount, bookingType, bookingId, formattedPayload, bookingObject) => {
        const { status, order_id, currency } = await paymentOrderId({
            amount: Math.round(amount * 100),
            currency: 'INR',
            booking_type: bookingType,
            booking_id: bookingId
        });

        if (status === "created") {
            const orderStateData = { order_id, currency, status, amount, Userdetails, booking_id: bookingId };

            // Navigate to PaymentProcessing page
            // Use the booking object passed directly (not from state)
            const successData = {
                bookingDetails: bookingObject, // Pass the full booking object which contains booking_id string
                bookingDate: formattedPayload?.start_date,
                slotTime: `${formattedPayload?.start_time} - ${formattedPayload?.end_time}`,
                paymentStatus: "Success",
                amountPaid: formattedPayload?.amount_paid
            };

            navigation('/payment-processing', {
                state: {
                    amount: amount,
                    bookingId: bookingId,
                    bookingType: bookingType,
                    bookingData: formattedPayload,
                    successData: successData,
                    paymentType: partialPayment ? 'partial' : 'normal',
                    orderState: orderStateData
                }
            });
        } else {
            toast.error("Payment failed");
        }
    }

    const handleAccordionToggle = (index) => {
        const accordionBody = document.getElementById(`accordion-collapse-body-${index}`);
        accordionBody.classList.toggle("hidden");
    };


    const onSubmit = (data) => {
        if (selectedSlot?.length == 0){
            toast.error("Please select a slot");
            return;
        }
        if(!isPaymentAllowed()){
            navigateToEditProfile();
            return;
        }
        
        setLoading(true);
        setTimeout(() => {
            try {
                const formattedPayload = {
                    start_date: moment(selectedDate).format('YYYY-MM-DD'),
                    end_date: moment(selectedDate).format('YYYY-MM-DD'),
                    start_time: moment(selectedSlot[0], "HH:mm").format('HH:mm:ss'),
                    end_time: slotEndTime,
                    court: selectedCourt,
                    sport: selectedSport?.value,
                    venue: venueDetails?.id,
                    user: Userdetails?.id,
                    amount_paid: partialPayment ? partialBookingFields?.totalAmount : normalBookingFields?.totalAmount,
                    payment_status: "Pending",
                    booked_from: "WEB APP",
                    addons: selectedAddons?.filter(item => item?.quantity > 0)?.map((item) => {
                        return { addon: item?.id, price: item?.price, quantity: item?.quantity }
                    }),
                    split_payment: false,
                    split_payment_members: [],
                    partial_payment: false,
                    partial_payment_amount: partialBookingFields?.totalAmount,
                    coupon: couponObjectData?.obj ? couponObjectData?.obj?.id : null,
                    calculated_response: calculatedResponse
                }
                
                const universalPayload = { booking_id: Number(bookingRegistered?.id), amount: Number(formattedPayload?.amount_paid), payment_status: "Paid" }
                const successObject = {
                    bookingDetails: bookingRegistered,
                    // bookingDate: bookingDetails?.booking_date,
                    slotTime: `${formattedPayload?.start_time} - ${formattedPayload?.end_time}`,
                    paymentStatus: "Success",
                    amountPaid: formattedPayload?.amount_paid
                }
                const onSuccess = async (bookingId = null) => {
                    // api call for updating it to payment status to success
                    await normalCourtPayment({...universalPayload, booking_id: bookingId ? bookingId : Number(bookingRegistered?.id)}).then((res) => {
                        if (res?.status == 'success') {
                            toast.success(res?.message);
                        } else {
                            toast.success(res?.message);
                        }
                    })
                }
    
                const onFailed = () => {
                    toast.error('Booking Failed')
                    // navigation.navigate('bookingFailed')
                }
    
                const splitPaymentOnSuccess = () => {
                    console.log("splitPaymentOnSuccess");
                    splitPaymentCourtPayment({ ...universalPayload, amount: Number(splitAmountData?.totalAmount) }).then((res) => {
                        if (res?.status == 'success') {
                            toast.success(res?.message);
                            // navigation.navigate('bookingSuccess', { bookingId: res?.data?.booking_id, bookingData: bookingDetails, afterPayment: { ...successObject, amountPaid: Number(splitAmountData?.totalAmount) } })
                        } else {
                            toast.error(res?.message);
                        }
                    }).catch((error) => {
                        console.log('error : ', error?.response);
                    })
    
                }
    
                const partialPaymentOnSuccess = () => {
                    console.log("partialPaymentOnSuccess");
                    try {
                        partialBookingCourtPayment({ ...universalPayload, amount: Number(partialPaymentDetails?.totalAmount) }).then((res) => {
                            console.log('res : ', res);
                            if (res?.status == 'success') {
                                toast.success(res?.message);
                                // navigation.navigate('bookingSuccess', { bookingId: res?.data?.booking_id, bookingData: bookingDetails, afterPayment: { ...successObject, amountPaid: Number(partialPaymentDetails?.totalAmount) } })
                            } else {
                                toast.error(res?.message);
                            }
                        })
                    } catch (error) {
                        console.log('error: ', error)
                    }
                }
    
                const internalRoutePayload = {
                    onSuccess: partialPayment ? partialPaymentOnSuccess : onSuccess,
                    onFailed
                }
                bookCourt(formattedPayload).then(async(res) => {
                    if (res?.data?.status == 'success') {
                        const bookingObject = res?.data?.data?.booking_id;
                        setBookingRegistered(bookingObject)
                        if( normalBookingFields?.totalAmount > 0){
                            // Pass the booking object directly instead of relying on state
                            generateOrderId(formattedPayload?.amount_paid, "court", bookingObject?.id, formattedPayload, bookingObject)
                        }else {
                            await onSuccess(bookingObject?.id)
                            navigation('/booking', {replace: true})
                        }
                        // processOnlinePayment(navigation, formattedPayload?.amount_paid, Userdetails, () => () => internalRoutePayload?.onSuccess(res?.data?.data?.booking_id), internalRoutePayload?.onFailed, "court", res?.data?.data?.booking_id?.id)
                    } else {
                        toast.error(res?.data?.message)
                    }
                })
            } catch (error) {
                console.log('error====================', error)
            }finally {
                setLoading(false)
            }
        },1000)
    };

    const courtListApi = (venueId, sportId) => {
        courtVenueSportFilter({ venue_id: venueId, sport_id: sportId })
            .then((res) => {
                if (res?.data?.length > 0) {
                    setCourtList(res?.data);
                    return res?.data;
                }
                setCourtList([]);
                return [];
            })
            .catch((err) => {
                console.log(err);
                return [];
            });
    };

    const handleSportChange = async (selectedOption) => {        
        setValue('sport', selectedOption);
        try {
            const matchedSport = venueDetails?.sports?.find(
                (sportItem) => selectedOption?.value === sportItem?.sport?.id
            )                        
            // if (matchedSport) {
            //     const response = await getAddOnsDetailsApi(matchedSport?.id)                
            //     setAddOns(response?.data)
            // }else{
            //     toast.error('No matching sport found');                
            //     setAddOns('');
            // }
        }
        catch (err) {
            console.log('Error:', err)
        }
    }

    useEffect(() => {
        if(selectedSlot?.length > 0 && selectedCourt){
            calculate()
        }
    },[selectedSlot, selectedAddons, selectedCourt, couponObjectData?.obj])


    useEffect(() => {
        getAllSlots();
    }, [selectedCourt, selectedDate, selectedSport, selectedCourtState?.slot_duration]);

    useEffect(() => {
        setSelectedCourtState(venueDetails?.courts?.find(court => court?.id == selectedCourt));
    }, [selectedCourt]);

    useEffect(() => {
        if (selectedSport && venueDetails?.id) {
            courtListApi(venueDetails?.id, selectedSport?.value);
            fetchAddonApi(venueDetails?.id, selectedSport?.value)
        }
    }, [selectedSport]);   

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if(!isPaymentAllowed()){
            warnUserBeforeBooking()
        }
    },[])

    return (
        <div className="flex flex-col sm:flex-row justify-center gap-4 my-4">
            {/* =================== Form ======================= */}
            <form onSubmit={handleSubmit(onSubmit)} className="max-w-[500px]">
                <div className="border-2 border-slate-200 rounded-lg">
                    {/* =================== Venue Details ============= */}
                    <div className='border-b-2 p-4 '>
                        <p className="font-bold text-xl capitalize">{venueDetails?.name}</p>
                        <div className='flex gap-2'>
                            <MapPin color='red' strokeWidth={1.25} size={20} />
                            <p className="capitalize">{venueDetails?.address}</p>
                        </div>
                        <div className='flex gap-2 items-center'>
                            <Phone color='red' strokeWidth={1.25} size={20} />
                            <p className="capitalize">{venueDetails?.contact_number}</p>
                        </div>
                        {(venueDetails?.partial_payment || venueDetails?.split_payment) && <div className='my-1 mt-2 border rounded-[10px] p-[1px] bg-gradient-to-bl from-[#FE0201] to-slate-500'>
                            <div className="p-2 bg-white rounded-[8px]">
                                <p className='bg-gradient-to-bl from-[#FE0201] to-slate-500 bg-clip-text text-transparent text-sm italic'>*Use the Players Turf App to have additional facilities like<br/>{`${venueDetails?.partial_payment ? 'Partial Payment' : ""}${(venueDetails?.partial_payment && venueDetails?.split_payment) ? ' and ' : "" }${venueDetails?.split_payment ? 'Split Payment' : ""}.`}</p>
                                <AppLinkIconSet border={false} />
                            </div>
                        </div>}
                    </div>


                    {/* =============== Date Picker ====================== */}
                    <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Date</p>
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => {
                                setSelectedDate(date);
                                setValue('date', date); // Update form state
                            }}
                            className='w-fit'
                            dateFormat="yyyy-MM-dd"
                            minDate={new Date()} // Disable dates before today
                            customInput={<CustomInput />}
                        />
                    </div>

                    {/*================= Sports Dropdown =================== */}
                    <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Sport</p>
                        <Select
                            options={sportsOptions}
                            onChange={handleSportChange}
                            getOptionLabel={(e) => (
                                <div className="flex items-center gap-2">
                                    <img
                                        src={e.image}
                                        alt={e.label}
                                        className="w-6 h-6 rounded-full"
                                    />
                                    <span>{e.label}</span>
                                </div>
                            )}
                            getOptionValue={(e) => e.value}
                            placeholder="Select Sport"
                        />
                    </div>

                    {/* ============= Court Selection DropDown ========================= */}
                    <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Court</p>
                        <select className={inputClass} {...register('court')} disabled={!selectedSport}>
                            <option value="">Select Court</option>
                            {courtList?.map((item, index) => (
                                <option key={index} value={item?.id}>
                                    {item?.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* ============= Coupon ========================= */}
                    <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Coupon</p>
                        <input
                            type='text'
                            className={inputClass}
                            value={couponObjectData?.name || ""}
                            placeholder="Enter Coupon Code"
                            onChange={(e) => {
                                setCouponObjectData((prevState) => {return {...prevState, name: e.target.value?.toUpperCase()}})
                            }}
                        />
                    </div>

                    <div className="flex flex-row justify-between mt-4 px-4">
                        <button type='button' className={`${formBtn1}`} onClick={handelCoupon}>
                            Apply Coupon
                        </button>
                        <div>
                            {couponObjectData?.errorMessage && <p className='text-red-500 text-sm'>{couponObjectData?.errorMessage || ""}</p>}
                            {couponObjectData?.obj && !couponObjectData?.errorMessage && 
                                <div className='flex flex-row justify-end items-center h-full gap-2'>
                                    <DiscountShape size="20" className='text-green-600' />
                                    <p className='text-sm text-green-600'>Coupon Applied</p>
                                </div>
                            }
                        </div>
                    </div>

                    {/* ============= Duration ========================= */}
                    <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Slot Duration</p>
                        <span className="capitalize font-semibold text-lg text-right">{selectedCourtState?.slot_duration ? selectedCourtState?.slot_duration : 0} min</span>
                    </div>

                    <div className="px-4 mt-4">
                        <div className='flex flex-row gap-2 items-center justify-between mb-2'>
                            <p className="capitalize font-semibold text-lg">Available Slots</p>
                            <div className='flex flex-row gap-2 items-center'>
                                <div className='flex flex-row gap-2 items-center'>
                                    <p className='p-1 w-2 h-2 rounded-full bg-gray-300' />
                                    <p className='text-sm'>Blocked</p>
                                </div>
                                <div className='flex flex-row gap-2 items-center'>
                                    <p className='p-1 w-2 h-2 rounded-full bg-red-400' />
                                    <p className='text-sm'>Booked</p>
                                </div>
                            </div>
                        </div>
                        {availableSlots.length > 0 && selectedDate && selectedCourt ? (
                            <div className="grid grid-cols-2 pt-2 gap-2 h-40 pb-5 overflow-y-auto bg-slate-100 rounded-md p-2 select-none">
                                {availableSlots.map((slot, index) => {
                                    const slotMoment = moment(`${moment(selectedDate).format('YYYY-MM-DD')} ${slot}`, 'YYYY-MM-DD HH:mm');
                                    const currentTime = moment();
                                    const isPastTime = slotMoment?.isBefore(currentTime);
                                    const isBooked = slotData?.booked_slots.includes(slot);
                                    const isBlocked = slotData?.blocked_slots.includes(slot);
                                    const isSelected = selectedSlot?.includes(slot);

                                    let slotClass = "bg-white text-gray-800 hover:bg-gray-100"; // Default style

                                    if (isBooked) {
                                        slotClass = "bg-red-400 text-white"; // Booked slot
                                    } else if (isBlocked) {
                                        slotClass = "bg-gray-300"; // Blocked slot
                                    } else if (isSelected) {
                                        slotClass = "bg-red-500 text-white"; // Selected slot
                                    } else if (isPastTime) {
                                        slotClass = "bg-gray-200"; // Passed time
                                    } else {
                                        slotClass = "bg-white"; // Available slot
                                    }

                                    // Calculate end time for display
                                    const endTime = moment(slotMoment).add(selectedCourtState?.slot_duration, 'minutes');

                                    return (
                                        <p
                                            key={index}
                                            className={`capitalize text-center font-semibold text-s w-full p-1 rounded-md ${isPastTime || isBlocked || isBooked ? "cursor-not-allowed" : "cursor-pointer"}  shadow-md ${slotClass}`}
                                            onClick={() => {
                                                if (!isPastTime && !isBlocked && !isBooked) {
                                                    handleSlotClick(slot);
                                                }
                                            }}
                                        >
                                            {`${slotMoment.format('hh:mm A')} - ${endTime.format('hh:mm A')}`}
                                        </p>
                                    );
                                })}
                            </div>
                        ) : (
                            <p className="capitalize font-semibold text-base py-1 text-center border rounded-md">No Slots Available</p>
                        )}
                    </div>


                    {/* ============== Slot Time Picker ================ */}
                    {/* <div className="grid grid-cols-2 items-center mt-4 px-4">
                        <p className="capitalize font-semibold text-lg">Start Time</p>
                        <div className="relative w-full">
                            <button
                                type='button'
                                className={`${inputClass} flex justify-between items-center`}
                                onClick={() => setTimeOpen(!timeOpen)}
                            >
                                <span className="font-semibold">{selectedSlot || 'Select a slot'}</span>
                                <Clock strokeWidth={1.25} size={20} />
                            </button>
                            {timeOpen && (
                                <div ref={dropdownRef} className="absolute mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-60 overscroll-y-auto overflow-scroll">
                                    <div className="grid grid-cols-2 gap-2 p-2">
                                        {availableSlots.map((slot, index) => (
                                            <button
                                                key={index}
                                                className={`p-2 rounded-lg text-center border ${selectedSlot === slot
                                                    ? 'bg-red-500 text-white'
                                                    : 'bg-white text-gray-800 hover:bg-gray-100'
                                                    }`}
                                                onClick={() => handleSlotClick(slot)}
                                            >
                                                {slot}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}

                        {selectedAddons?.length > 0 &&
                            <>
                                <p className="font-semibold text-lg py-4 mx-4 pb-0">Addons</p>
                                <div className="p-2 mx-4 flex flex-row flex-wrap bg-slate-200 gap-2 rounded-md min-w-[310px]">
                                    {selectedAddons?.map((addon, index) => (
                                        <div className={`flex flex-row bg-white px-4 py-3 justify-between items-start rounded-[10px] w-full`} key={index}>
                                            <div className="flex flex-1 self-start flex-col">
                                                <label className={`font-semibold capitalize`}>{addon?.name}</label>
                                                <div id="accordion-collapse" data-accordion="collapse">
                                                    <h2 id={`accordion-collapse-button-${index}`}>
                                                        <p onClick={() => handleAccordionToggle(index)} className="text-gray-400 text-sm -mt-0.5 inline-flex items-center space-x-2" data-accordion-target={`#accordion-collapse-body-${index}`} aria-expanded="true" aria-controls={`accordion-collapse-body-${index}`}>
                                                            <span>Description</span>
                                                            <ArrowDown2 size={22} color="#a8a29e" weight="bold" />
                                                        </p>
                                                    </h2>
                                                    <div id={`accordion-collapse-body-${index}`} class="hidden" aria-labelledby={`accordion-collapse-heading-${index}`}>
                                                        <label className={`text-gray-400 text-sm -mt-1`}>{addon?.description}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col text-right self-start justify-between font-semibold">
                                                <p className="mb-1">{addon?.price}</p>
                                                <div className={`flex flex-row ml-3 space-x-3 bg-background/30  px-2 py-1 rounded-full`}>
                                                    <MinusCircle size={25} className={`text-primary`} weight="bold" onClick={() => {
                                                            onDecrement(addon?.id)
                                                    }} />
                                                    <p>{addon?.quantity}</p>
                                                    <PlusCircle size={25} className={`text-primary`} weight="bold" onClick={() => {
                                                            onIncrement(addon?.id)
                                                    }} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>}

                    {/* ============== Form Submit Button ============= */}
                    <div className='px-4 pb-2'>
                        <button
                            type="submit"
                            className={`${formBtn1} !w-full mt-4 ${(!selectedCourt || selectedCourt === '' || !selectedSport || !selectedSlot || selectedSlot?.length == 0 || loading) ? 'bg-slate-300 cursor-not-allowed' : ''}`}
                            disabled={!selectedCourt || selectedCourt === '' || !selectedSport || !selectedSlot || selectedSlot?.length == 0 || loading}
                        >
                            {(!unitSlotPriceObject) ? 'Add To Cart' : `Proceed To Pay ₹ ${partialPayment? partialBookingFields?.totalAmount : normalBookingFields?.totalAmount}/-`}
                        </button>
                    </div>
                </div>
            </form>

            {/* =================== Cart ======================= */}
            <div className='col-span-1 lg:col-span-2 rounded-lg border-2 h-fit min-w-[300px] max-w-[600px]'>
                {
                    (!selectedCourt || selectedCourt === '' || !selectedSport || !selectedSlot || selectedSlot?.length == 0) ? (
                        <div className="flex flex-col items-center justify-center h-full">
                            <ShoppingCart strokeWidth={1.25} size={80} color="#64748B" />
                            <p className="font-semibold text-lg text-slate-500">Empty Cart</p>
                        </div>
                    ) : (
                        <div>
                            <div className="flex justify-between items-center border-b-2 px-4 py-2">
                                <p className="font-bold text-xl capitalize">Cart</p>
                                {/* ============== Discard Button ==================== */}
                                <button type="button" onClick={discardFunc}>
                                    <Trash2 color="red" />
                                </button>
                            </div>
                            <div className='py-4'>
                                <div className="flex items-center gap-2 px-2 ">
                                    <LandPlot color='red' strokeWidth={1.25} />
                                    <label className="font-semibold">Sport : <span className='font-normal'>{selectedSport?.label}</span></label>
                                </div>
                                <div className="flex items-center gap-2 px-2 mt-4">
                                    <CalendarCheck2 color='red' strokeWidth={1.25} />
                                    <label className="font-semibold">
                                        Date : <span className='font-normal'>{moment(selectedDate).format("DD, MMMM YYYY")}</span>
                                    </label>
                                </div>
                                <div className="flex items-center gap-2 px-2 mt-4">
                                    <Clock color='red' strokeWidth={1.25} />
                                    <label className="font-semibold">Slot : <span className='font-normal'>{`${moment(selectedSlot[0], 'HH:mm').format('hh:mm A')} - ${slotEndTime !== '--' ? moment(slotEndTime, 'HH:mm:ss').format('hh:mm A') : '--'}`}</span></label>
                                </div>
                                <div className="flex items-center justify-between px-2 mt-4">
                                    <div className="flex items-center gap-2">
                                        <Timer color='red' strokeWidth={1.25} />
                                        <label className="font-semibold capitalize">Duration : <span className='font-normal'>{selectedCourtState?.slot_duration} min</span></label>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-between mt-4 mx-2 gap-2'>
                                    <div className='flex flex-row gap-2'>
                                        <Banknote color='red' strokeWidth={1.25} />
                                        <p className='font-semibold'>Break-Even Price</p>
                                    </div>
                                    <ArrowDown2
                                        size={22}
                                        color='red'
                                        className={`transition-transform duration-300 ${!toggleDropDown.normalPriceBreakup ? "rotate-0" : "rotate-180"}`}
                                        onClick={() => {
                                            setToggleDropDown((prevSate) => {return {
                                                ...prevSate, normalPriceBreakup: !prevSate.normalPriceBreakup
                                            }})
                                        }}
                                    />
                                </div>
                                {toggleDropDown.normalPriceBreakup && 
                                <>
                                    <div className='border-t mx-2' />
                                    <div className="flex flex-col px-5 py-2 mt-3 mx-5 text-sm bg-gray-100 rounded-md">
                                        <label className="font-semibold capitalize">Slot Price : ₹ <span className='font-normal'>{unitSlotPriceObject?.sport_price}</span></label>
                                        <label className="font-semibold capitalize">Addon Price : ₹ <span className='font-normal'>{(normalBookingFields?.addonPrice)?.toFixed(2)}</span></label>
                                        <label className="font-semibold capitalize">GST : ₹ <span className='font-normal'>{(normalBookingFields?.gstPrice)?.toFixed(2)}</span></label>
                                        <label className="font-semibold capitalize">Convenience Fee : ₹ <span className='font-normal'>{(normalBookingFields?.platformFeePrice)?.toFixed(2)}</span></label>
                                        <label className="font-semibold capitalize">Coupon Discount : <span className='font-normal'>{`(-)`}</span> ₹ <span className='font-normal'>{(normalBookingFields?.discountedPrice)?.toFixed(2)}</span></label>
                                    </div>
                                </>
                                }
                                <div className='mx-3 mt-4 border-b-2 border-dashed' />
                                <div className="flex items-center justify-between px-2 mt-4">
                                    <div className="flex items-center gap-2">
                                        <Banknote color='red' strokeWidth={1.25} />
                                        <label className="font-semibold capitalize">Grand Total Price : ₹ <span className='font-normal'>{(normalBookingFields?.totalAmount).toFixed(2)}</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            <div />
        </div>

    );
}

export default SlotBooking;
